import state from './moduleLhdnSubmissionsState.js'
import mutations from './moduleLhdnSubmissionsMutation.js'
import actions from './moduleLhdnSubmissionsActions.js'
import getters from './moduleLhdnSubmissionsGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
